import styled from 'styled-components';
import { media } from 'baseline-ui/layout';
import purpleBackground from 'assets/images/Favepage_Purple_Back.jpg';
import BackgroundBase from './BackgroundBase';

const BackgroundTriangeSidePurple = styled(BackgroundBase)`
    background-image: url(${purpleBackground});
    background-size: contain;

    ${media.mobile} {
        background-image: url(${purpleBackground});
        background-size: cover;
        background-position: center;
    }
`;

export default BackgroundTriangeSidePurple;